<template>
  <div
    id="wrapper"
    class="type-form-wrapper"
    data-tf-widget="LCAnu5"
    data-tf-inline-on-mobile
    data-tf-medium="snippet"
    :data-tf-hidden="typeformHiddenFields"
  ></div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";

const ATTRIBUTION_KEYS = [
  "fbclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "campaign_id",
  "adset_id",
  "ad_id",
  "placement",
  "landing_page",
  "lead_source",
];

export default {
  setup() {
    const route = useRoute();

    const typeformHiddenFields = computed(() =>
      ATTRIBUTION_KEYS.reduce((fields, key) => {
        const value = route.query[key];

        if (typeof value === "string" && value.trim()) {
          fields.push(`${key}=${encodeURIComponent(value.trim())}`);
        }

        return fields;
      }, []).join(","),
    );

    onMounted(() => {
      const existingEmbedScript = document.querySelector(
        'script[src="//embed.typeform.com/next/embed.js"]',
      );

      if (existingEmbedScript) {
        existingEmbedScript.remove();
      }

      const embedJs = document.createElement("script");
      embedJs.setAttribute("src", "//embed.typeform.com/next/embed.js");
      document.head.appendChild(embedJs);
    });

    return { typeformHiddenFields };
  },
};
</script>
<style>
.inner-wrapper {
  @apply h-full;
}
.type-form-wrapper {
  @apply h-full;
}
</style>
